module.exports = __webpack_public_path__ + "static/media/indians.2d5fefbb.mp3";